import { defineMessages } from 'react-intl';

export default defineMessages({
    baCoverages: {
        id: 'endorsement.ba.directives.templates.ba-edit-coverage.Coverages',
        defaultMessage: 'Coverages',
    },
    lineCoverages: {
        id: 'endorsement.ba.directives.templates.ba-edit-coverage.Line Coverages',
        defaultMessage: 'General Coverages (Apply to all vehicles)',
    },
    vehicleCoverages: {
        id: 'endorsement.ba.directives.templates.ba-edit-coverage.Vehicle Coverages',
        defaultMessage: 'Vehicle Coverages',
    },
    saveCoverageError: {
        id: 'endorsement.ba.config.Unable to save coverages change',
        defaultMessage: 'Unable to save coverages change'
    },
    saveCoverageErrorMessage: {
        id: 'endorsement.ba.config.An error occurred while attempting to save coverage changes',
        defaultMessage: 'An error occurred while attempting to save coverage changes'
    }
});
